// removed by extract-text-webpack-plugin
module.exports = {"container":"C5uD8L41HbHLcQ8-ZT2_i_1","intro":"opDRPXuampjlL-kw2nKFR_1","list":"_25cC-eiyIFFlgVzyWQtiq8_1","item":"_12eQGhcuhgh0bcP-dNUeSt_1","link":"LerMKb-dVYpqSyVcEbS6L_1"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_1","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c26f7ba","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/AppNavigation.vue
// module id = BLVt
// module chunks = 1